import styled from "styled-components"
import media from "styled-media-query"

import BackgroundImage from "gatsby-background-image"

export const Wrapper = styled(BackgroundImage)`
  width: 100%;
  height: 380px;
  overflow: hidden;
  max-height: 380px;
  background-color: var(--backgroundHero);

  background-size: contain;
  background-position: 75% 100%;
  background-repeat: no-repeat;

  ${media.greaterThan("1200px")`
    background-size: 30%;
  `}

  ${media.lessThan("medium")`
    min-height: 295px;
    max-height: 295px;
  `}

  ${media.lessThan("440px")`
    min-height: 390px;
    max-height: 480px;
  `}

`

export const Content = styled.div`
  max-width: 1190px;
  height: 100%;
  margin: 0 auto;
  display: flex;

  ${media.greaterThan("medium")`
    padding: 40px 50px 80px;
  `}

  ${media.greaterThan("large")`
    padding: 40px 50px 80px;
  `}

  ${media.lessThan("medium")`
    flex-direction: column;
    padding: 40px 40px 80px 40px;
  `}

  ${media.lessThan("520px")`
    flex-direction: column;
    padding: 40px 14px 80px 14px;
  `}
`

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  ${media.greaterThan("1110px")`
    padding: 30px 0 0 30px;
  `}

  ${media.lessThan("small")`
  padding-left: 10px;
  `}
`

export const Text = styled.div`
  ${media.lessThan("large")`
    padding-left: 10px;
  `}

  ${media.lessThan("medium")`
    padding-top: 0;
  `}
`

export const Title = styled.h1`
  font-weight: 400;
  line-height: 60px;
  color: var(--titleHomeColor);
  width: 587px;

  span {
    display: block;
    color: var(--highlight); 
  }

  ${media.greaterThan("medium")`
    max-width: 95%;
    font-size: 40px;
  `}

  ${media.greaterThan("large")`
    font-size: 44px;
    line-height: 64px;
  `}

  ${media.lessThan("medium")`
    font-size: 36px;
    line-height: 50px;
    max-width: 500px;
  `}

  ${media.lessThan("520px")`
    width: 100%;
    font-size: 28px;
    line-height: 45px;

    span {
      display: block;
    }
  `}

  ${media.lessThan("410px")`
    font-size: 27px;
    line-height: 40px;
  `}

`
